export const iterablesAreEqual = <A>(a: Iterable<A>, b: Iterable<A>): boolean => {
  const setA = new Set(a);
  const setB = new Set(b);

  if (setA.size !== setB.size) {
    return false;
  }

  for (const value of setA) {
    if (!setB.has(value)) {
      return false;
    }
  }

  // if size is equal and we've asserted that all of A is
  // in B then "all of B is in A" should be implied
  return true;
};
